import httpClient from "Api/httpClient";

const END_POINT = "/rfqs";

const getRfqs = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getRfq = (rfq_id) => {
    if (!rfq_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + rfq_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printRfq = (rfq_id, view_as = null) => {
    if (!rfq_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?rfq_id=" + rfq_id + "&view_as=" + view_as;
    return httpClient.get(SINGLE_END_POINT);
};

const createRfqs = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateRfqs = (payload, rfq_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + rfq_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteRfqs = (rfq_id) => {
    const DELETE_END_POINT = END_POINT + "/" + rfq_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const createQuoteFromRfq = (payload, rfq_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CONVERT_END_POINT = "/quotes/create_from_rfq/" + rfq_id;
    return httpClient.post(CONVERT_END_POINT, body);
};

const createPoFromRFQ = (payload, rfq_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CONVERT_END_POINT = "/purchase_orders/create_from_rfq/" + rfq_id;
    return httpClient.post(CONVERT_END_POINT, body);
};

export { getRfqs, getRfq, printRfq, createRfqs, updateRfqs, deleteRfqs, createQuoteFromRfq, createPoFromRFQ };
